<template>
    <ui-modal
        v-model="valueLocal"
        :fullscreen="fullscreen"
        transparent
        :close-class-list="closeClassList"
    >
        <div
            ref="content"
            class="premium-modal__content"
        >
            <slot />
        </div>
    </ui-modal>
</template>
<script>
export default {
    name: 'PremiumModal',
    props: {
        value: Boolean,
        fullscreen: Boolean,
        closeClassList: String,
    },
    data() {
        return {
            valueLocal: false,
            isTouched: undefined,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.valueLocal = val;
            },
        },
        valueLocal(val) {
            if (this.value !== val) this.$emit('input', val);
        },
    },
    methods: {
        onMove(e) {
            if (!this.$refs.content) return;
            if (!this.value) return;

            let delta = 0;
            if (e.type === 'wheel') {
                delta = e.wheelDeltaY;
            } else if (this.isTouched !== undefined) {
                delta = e.touches?.[0].clientY - this.isTouched;
                this.isTouched = e.touches?.[0].clientY;
            }

            const { scrollTop } = this.$refs.content;
            this.$refs.content.scrollTop = scrollTop - delta;
        },
        onStart(e) {
            if (!this.value) return;
            this.isTouched = e.touches?.[0].clientY;
        },
        onEnd() {
            if (!this.value) return;
            this.isTouched = undefined;
        },
    },
    mounted() {
        if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
            window.addEventListener('touchstart', this.onStart, { passive: true });
            window.addEventListener('touchend', this.onEnd, { passive: true });
            window.addEventListener('touchmove', this.onMove, { passive: true });
        } else {
            window.addEventListener('wheel', this.onMove, { passive: true });
        }

    },
    beforeDestroy() {
        window.removeEventListener('touchstart', this.onStart, { passive: true });
        window.removeEventListener('touchend', this.onEnd, { passive: true });
        window.removeEventListener('touchmove', this.onMove, { passive: true });
        window.removeEventListener('wheel', this.onMove, { passive: true });
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

.premium-modal {
    &__content {
        width: 100%;
        height: 100%;
        background: $graphite-second;
        overflow: hidden;
        scroll-behavior: auto;
    }
    &__close {
        user-select: none;
        @include fluid('top', 56px, 43px);
        @include fluid('right', 350px, 16px);
    }
}
</style>
